import { render, staticRenderFns } from "./ProjectDescriptionAdd.vue?vue&type=template&id=44053c84&scoped=true"
import script from "./ProjectDescriptionAdd.vue?vue&type=script&lang=js"
export * from "./ProjectDescriptionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44053c84",
  null
  
)

export default component.exports